import React from "react";

/**
 * Styles partagés par les sections du thème 2026.
 * Chaque section importe `sharedStyles` et concatène ses propres styles.
 */
export const sharedStyles = `
.t26-section {
  padding: clamp(32px, 5vw, 64px) clamp(16px, 4vw, 32px);
  max-width: var(--container);
  margin-inline: auto;
}
.t26-section__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: clamp(20px, 3vw, 32px);
}
.t26-section__eyebrow {
  display: inline-flex; align-items: center; gap: 6px;
  font-family: var(--font-body);
  font-size: 11px; font-weight: 700;
  letter-spacing: .22em; text-transform: uppercase;
  color: var(--secondary);
  margin-bottom: 10px;
}
.t26-section__title {
  font-family: var(--font-display);
  margin: 0;
  font-size: clamp(24px, 3.4vw, 38px);
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -.01em;
  line-height: 1.15;
  text-wrap: balance;
}
.t26-section__title em {
  font-style: italic;
  color: color-mix(in oklab, var(--primary) 80%, var(--secondary) 20%);
}
.t26-section__sub {
  margin: 10px 0 0;
  font-size: 15px;
  color: var(--ink-3);
  max-width: 60ch;
  text-wrap: pretty;
}
.t26-section__more {
  display: inline-flex; align-items: center; gap: 10px;
  margin-top: clamp(20px, 3vw, 32px);
  font-size: 14px; font-weight: 600;
  color: var(--ink);
}
.t26-section__more-arrow {
  display: inline-flex; align-items: center; justify-content: center;
  width: 32px; height: 32px;
  border-radius: 50%;
  background: var(--primary);
  color: var(--primary-contrast);
  transition: transform .15s ease;
}
.t26-section__more:hover .t26-section__more-arrow {
  transform: translateX(3px);
}
[dir="rtl"] .t26-section__more:hover .t26-section__more-arrow {
  transform: translateX(-3px);
}

.t26-section__empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--ink-3);
  font-size: 14px;
}
.t26-section--center { text-align: center; }
`;

/**
 * En-tête de section standard : eyebrow optionnel + titre + sous-titre optionnel.
 */
export function SectionHead({ eyebrow, title, subtitle, children }) {
    if (!title && !subtitle && !eyebrow && !children) return null;
    return (
        <header className="t26-section__head">
            {eyebrow && <span className="t26-section__eyebrow">{eyebrow}</span>}
            {title && <h2 className="t26-section__title">{title}</h2>}
            {subtitle && <p className="t26-section__sub">{subtitle}</p>}
            {children}
        </header>
    );
}
